import {GUEST_LOCALE_STORAGE_KEY} from '@toolify/client/src/modules/authentication/constants/guestAppearanceStorageKeys'

export function getStoredGuestLocale(): string | undefined {
  if(typeof localStorage === 'undefined') {
    return undefined
  }
  return localStorage.getItem(GUEST_LOCALE_STORAGE_KEY) || undefined
}
